import { useCallback, useMemo } from 'react';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';

import {
  explorerRestaurantListPayloadAtom,
  restaurantHasLimitReachedAtom,
  explorerRestaurantListLoadingAtom,
} from '../job-explorer-restaurant-explorer.atoms';
import { Button as ButtonV2 } from '@restworld/ui-ds-base';
import {
  jobListParamsAtom,
  jobLocationPositionListLoadingAtom,
  jobListHasLimitReachedAtom,
} from '../job-explorer-list.atoms';

export const PaginationButton = ({ fullwidth = true }: { fullwidth?: boolean }) => {
  const setJobListParams = useSetAtom(jobListParamsAtom);
  const setExplorerRestaurantListPayload = useSetAtom(explorerRestaurantListPayloadAtom);
  const jobLocationPositionListLoading = useAtomValue(jobLocationPositionListLoadingAtom);
  const explorerRestaurantListLoading = useAtomValue(explorerRestaurantListLoadingAtom);
  const hasFetchRestaurantListLimitReached = useAtomValue(restaurantHasLimitReachedAtom);
  const jobListHasLimitReached = useAtomValue(jobListHasLimitReachedAtom);

  const onClickHandler = useCallback(() => {
    !hasFetchRestaurantListLimitReached &&
      setExplorerRestaurantListPayload((p) => ({ ...p, offset: p.offset + 3, limit: 3 }));
    !jobListHasLimitReached && setJobListParams((p) => ({ ...p, offset: p.offset + 7, limit: 7 }));
  }, [hasFetchRestaurantListLimitReached, jobListHasLimitReached, setExplorerRestaurantListPayload, setJobListParams]);

  const disabled = useMemo(
    () =>
      (hasFetchRestaurantListLimitReached && jobListHasLimitReached) ||
      jobLocationPositionListLoading ||
      explorerRestaurantListLoading,
    [
      explorerRestaurantListLoading,
      hasFetchRestaurantListLimitReached,
      jobListHasLimitReached,
      jobLocationPositionListLoading,
    ]
  );

  const { t } = useTranslation('common');

  return (
    <ButtonV2
      onClick={onClickHandler}
      variant="tertiary"
      disabled={disabled}
      fullwidth={fullwidth}
      testId="explorer-pagination-button"
    >
      {t('show_more')}
    </ButtonV2>
  );
};
